const setores = {
  DRF: 'DRF',
  DCF: 'DCF',
  GSF: 'GSF',
  GET: 'GET',
  DIGOF: 'DIGOF',
  DIPRE: 'DIPRE',
  DDT: 'DDT',
  DAD: 'DAD',
  DIGEF: 'DIGEF',
  PROTOCOLO: 'PROTOCOLO',
  PRODUTIVIDADE: 'PRODUTIVIDADE',
  RELATORIOS: 'RELATORIOS',
  FINANCEIRO: 'FINANCEIRO',
  GOVERNO: 'GOVERNO',
  DRV: 'DRV',
  DSF: 'DSF'
}

const setoresFormatado = {
  DRF: 'DRF',
  DCF: 'DCF',
  GSF: 'GSF',
  GET: 'GET',
  DIGOF: 'DIGOF',
  DIPRE: 'DIPRE',
  DDT: 'DDT',
  DAD: 'DAD',
  DIGEF: 'DIGEF',
  PROTOCOLO: 'Protocolo',
  FINANCEIRO: 'Financeiro',
  DRV: 'DRV',
  DSF: 'DSF',
  RELATORIOS: 'Relatórios',
  PRODUTIVIDADE: 'Produtividade',
  GOVERNO: 'Governo'
}

export const nomesSetores = {
  DRF: 'Divisão de Registros Fundiários',
  DCF: 'Divisão de Cartografia Fundiária',
  GSF: 'Gestão de Serviços Fundiários',
  GET: 'Gestão Técnica',
  DIGOF: 'Diretoria de Governança Fundiária',
  DIPRE: 'Diretoria Presidência',
  DDT: 'Divisão de Documentos de Titulação',
  DAD: 'Divisão de Análise e Correção de Documentos',
  DIGEF: 'Diretoria de Gestão e Desenvolvimento Fundiário',
  PROTOCOLO: 'Protocolo',
  PRODUTIVIDADE: 'Produtividade',
  RELATORIOS: 'Relatórios',
  FINANCEIRO: 'Financeiro',
  GOVERNO: 'Governo',
  DRV: 'Divisão Regional de Vistoria',
  DSF: 'Diretoria de Serviços Fundiários'
}

export const setoresInformacao = [
  'DRF',
  'DCF',
  'GSF',
  'GET',
  'DIGOF',
  'DIPRE',
  'DDT',
  'DAD',
  'DIGEF',
  'DRV',
  'DSF'
]

export const setoresOrigemInformacao = []

export default {
  setores,
  nomesSetores,
  setoresFormatado
}



// WEBPACK FOOTER //
// ./src/utils/rr/setor.js